import { apiClient } from "../../../../lib/axios";
import type {
  FilterOptionsResponse,
  UsersFilterOptionsResponse,
  FilterOptionsApiParams,
  DepartmentOptionsResponse,
  RegionOptionsResponse,
} from "./types";

export const filterOptionsApi = {
  getDepartments: async (
    clientId?: string | null,
    bypassAnonymisation?: boolean,
    withData?: boolean,
    regionIds?: string[]
  ): Promise<DepartmentOptionsResponse> => {
    const response = await apiClient.get(
      "/admin/programme-profile/filter-options/departments",
      {
        params: clientId
          ? {
              client_id: clientId,
              bypass_anonymisation: bypassAnonymisation || undefined,
              with_data: withData || undefined,
              region: regionIds && regionIds.length > 0 ? regionIds : undefined,
            }
          : undefined,
      }
    );
    return response.data;
  },

  getRegions: async (
    clientId?: string | null
  ): Promise<RegionOptionsResponse> => {
    const response = await apiClient.get(
      "/admin/programme-profile/filter-options/regions",
      {
        params: clientId ? { client_id: clientId } : undefined,
      }
    );
    return response.data;
  },

  getShiftPatterns: async (
    clientId?: string | null
  ): Promise<FilterOptionsResponse> => {
    const response = await apiClient.get(
      "/admin/programme-profile/filter-options/shift-patterns",
      {
        params: clientId ? { client_id: clientId } : undefined,
      }
    );
    return response.data;
  },

  getAgeRanges: async (
    clientId?: string | null
  ): Promise<FilterOptionsResponse> => {
    const response = await apiClient.get(
      "/admin/programme-profile/filter-options/age-ranges",
      {
        params: clientId ? { client_id: clientId } : undefined,
      }
    );
    return response.data;
  },

  getSexOptions: async (
    clientId?: string | null
  ): Promise<FilterOptionsResponse> => {
    const response = await apiClient.get(
      "/admin/programme-profile/filter-options/sex",
      {
        params: clientId ? { client_id: clientId } : undefined,
      }
    );
    return response.data;
  },

  getUsers: async (
    params?: FilterOptionsApiParams & { client_id?: string | null }
  ): Promise<UsersFilterOptionsResponse> => {
    const response = await apiClient.get(
      "/admin/programme-profile/filter-options/users",
      {
        params: {
          search: params?.search || "",
          limit: params?.limit || 20,
          offset: params?.offset || 0,
          user_ids:
            params?.user_ids && params.user_ids.length > 0
              ? params.user_ids
              : undefined,
          client_id: params?.client_id || undefined,
          bypass_anonymisation: params?.bypass_anonymisation || undefined,
        },
      }
    );
    return response.data;
  },
};
